// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"009a48f7","112":"749f68c1","381":"855b18c9","453":"e32c4614","461":"b82ae979","526":"2ca3386e","694":"f73b8b84","718":"9bda5365","743":"9d26b51c","885":"39bef299","900":"12009dd5","931":"175528ff"}[chunkId] + ".chunk.js";
};